module.exports = __webpack_public_path__ + "static/Victory Chapel -Map-ea8ee69da5e245dc23d231e71386ee77.jpg";